import Link from '@/components/UI/Link';
import { type FC } from 'react';

/**
 * Displayed when the server returns a 429 Too Many Requests response,
 * informing the user they have been rate limited and should wait before retrying.
 */
const RateLimited: FC = () => {
  return (
    <div className="message-page" data-test-component="RateLimited" data-test-element="container">
      <div className="ui-card pa3 pa4-l mv6 tc">
        <h2 className="normal f3 f2-l black pb3" data-test-element="heading">
          Too many requests.
        </h2>
        <p className="f5 f4-l pb3" data-test-element="description">
          You have made too many requests in a short period of time. Please wait a moment before trying again.
        </p>
        <Link to="/" className="button">
          Return to home
        </Link>
      </div>
    </div>
  );
};

export default RateLimited;
